import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductByID } from "../../services/productService";
import Loader from "../../components/Loader";
import { updateToCart} from "../../redux/features/cartSlice";
import ProductCarousel from "../../components/product/ProductCarousel";

function ProductDetail() {
  const navigate = useNavigate();
  const { id } = useParams();
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const {product, loader} = useSelector(state => state.product);
  const [quantity, setQuantity] = useState(1);

  const {items} = useSelector((state) => state.cart);
  const handleAddToCart = () => {
    dispatch(updateToCart({product:product, qty:quantity}));
    navigate('/cart');
  }
  const filterQtyCurrentProduct = () => {
    const item = items.find((item)=>item.id === id)
    if(item) {
      setQuantity(item.quantity)
    }
  }
  useEffect(() => {
    filterQtyCurrentProduct()
      dispatch(fetchProductByID(id));
  }, [id, dispatch]);

  const handleincrementQuantity = () =>{
    setQuantity(prevState=> prevState+1);
  }
  const handledecrementQuantity = () =>{
    if(quantity > 1) {
      setQuantity(prevState=> prevState-1);
    }
  }
  const handleChangeQuantity = (e) => {
    const valueQty = Number(e.target.value)
    if(valueQty >= 1) {
      setQuantity(valueQty)
    }

  }
  if(loader) return <Loader />
  return (
    <>
      <div className="container mx-auto p-6">
        {product ? (
          <div className="flex flex-col md:flex-row bg-white">
            <div className="w-full md:w-1/2 p-4">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-auto object-cover rounded-md"
              />
            </div>
            <div className="w-full md:w-1/2 p-6">
              <h1 className="text-2xl font-bold text-gray-800 ">
                {product.name}
              </h1>
              <span className="text-gray-400 mb-4 block">{product.category.name}</span>
              <p className="text-xl text-gray-600 font-semibold mb-4">
                {product.price} MAD
              </p>
              <p className="text-gray-700 mb-6">{product.description}</p>
              <div className="mb-4">
                <label
                  htmlFor="quantity"
                  className="block text-gray-700 font-medium mb-2"
                >
                  Quantity *
                </label>
                <div className="w-[120px] h-full px-[26px] flex items-center border border-qgray-border">
                <div className="flex justify-between items-center w-full">
                <button onClick={handledecrementQuantity} >-</button>
                <input
                  type="number"
                  id="quantity"
                  className="w-full p-2 text-center text-gray-700  outline-0"
                  value={quantity}
                  onChange={handleChangeQuantity}
                />
                
                <button onClick={handleincrementQuantity}>+</button>
                </div>
              </div>
              </div>
              <div className="flex-1 h-full">
              <button onClick={handleAddToCart}  className="w-full bg-primaryColor text-white py-2 rounded-md transition">
                {t('button.addToCart')}
              </button>
              </div>
            </div>
          </div>
        ) : (
          <p>Chargement des détails...</p>
        )}
      </div>
      
      <div  className="container mx-auto p-6">
      {product && product.category.id && (
        <div className="carouselPdts">
          <ProductCarousel categoryId={product.category.id} />
        </div>
      )}
      </div>
    </>
  );
}
export default ProductDetail;
